import type { BetterFeatureClientPlugin } from "@di-devs/better-feature/client";
import type { systemSettings } from "../server/plugin";
import { createSystemSettingsPlugin } from "./system-settings/plugin";

export const systemSettingsClient = () => {
	return {
		id: "system-settings",
		$InferServerPlugin: {} as ReturnType<typeof systemSettings>,
		getAtoms: ($fetch) => {
			// Create subfeature plugin
			const settingsPlugin = createSystemSettingsPlugin($fetch);

			return {
				// System settings signals
				$getSystemSettingsSignal: settingsPlugin.signals.getSystemSettings,
				$getPublicSettingsSignal: settingsPlugin.signals.getPublicSettings,
				$getSystemSettingSignal: settingsPlugin.signals.getSystemSetting,
				$setSystemSettingSignal: settingsPlugin.signals.setSystemSetting,
				$setBulkSystemSettingsSignal:
					settingsPlugin.signals.setBulkSystemSettings,
				$deleteSystemSettingSignal: settingsPlugin.signals.deleteSystemSetting,
				$getFaviconSignal: settingsPlugin.signals.getFavicon,
				$setFaviconSignal: settingsPlugin.signals.setFavicon,
				$getLogoSignal: settingsPlugin.signals.getLogo,
				$setLogoSignal: settingsPlugin.signals.setLogo,
				$getStorePicSignal: settingsPlugin.signals.getStorePic,
				$setStorePicSignal: settingsPlugin.signals.setStorePic,

				// System settings queries - Better Feature will add "use" prefix automatically
				getSystemSettings: settingsPlugin.queries.getSystemSettings,
				getPublicSettings: settingsPlugin.queries.getPublicSettings,
				getSystemSetting: settingsPlugin.queries.getSystemSetting,
				setSystemSetting: settingsPlugin.queries.setSystemSetting,
				setBulkSystemSettings: settingsPlugin.queries.setBulkSystemSettings,
				deleteSystemSetting: settingsPlugin.queries.deleteSystemSetting,
				getFavicon: settingsPlugin.queries.getFavicon,
				setFavicon: settingsPlugin.queries.setFavicon,
				getLogo: settingsPlugin.queries.getLogo,
				setLogo: settingsPlugin.queries.setLogo,
				getStorePic: settingsPlugin.queries.getStorePic,
				setStorePic: settingsPlugin.queries.setStorePic,

				// State atoms
				...settingsPlugin.atoms,
			};
		},
		getActions: ($fetch, $store) => {
			// Create subfeature plugin with store
			const settingsPlugin = createSystemSettingsPlugin($fetch, $store);

			return {
				...settingsPlugin.actions,
			};
		},
		atomListeners: [],
	} satisfies BetterFeatureClientPlugin;
};
